const ToursHero = () => {
  return <section className="relative isolate overflow-hidden border-t border-amber-100 bg-[#07130d] py-20 sm:py-24 lg:py-40 xl:py-56">
            <img
    src="/images/Drive Ceylon/kandy/SL_Kandy_asv2020-01_img04_Queens_Hotel.webp"
    alt="Hintergrundbild für eine Reise durch Kultur und Natur Sri Lankas"
    className="object-cover object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="eager" fetchPriority="high" />

            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/70" />

            <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto flex min-h-[360px] max-w-5xl items-center justify-center sm:min-h-[420px] lg:min-h-[520px]">
                    <div className="w-full max-w-4xl p-4 text-center text-white sm:p-6 lg:px-10 lg:py-8">
                        <div className="absolute left-8 top-10 hidden lg:block">
                            <svg width="289" height="245" viewBox="0 0 289 245" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M289 1H1V244.5" stroke="white" strokeWidth="2" />
                            </svg>
                        </div>

                        <div className="absolute -bottom-12 right-8 hidden lg:block">
                            <svg width="289" height="244" viewBox="0 0 289 244" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 243.5H288V0" stroke="white" strokeWidth="2" />
                            </svg>
                        </div>

                        <div className="mx-auto mb-6 h-1.5 w-20 rounded-full bg-gradient-to-r from-[#F28600] to-[#ffb347]" />

                        <h1 className="font-serif text-4xl font-light leading-tight tracking-tight sm:text-5xl lg:text-6xl">
                            Reise durch die Geheimnisse und Kulturen Sri Lankas
                        </h1>

                        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-white/88 sm:text-xl lg:text-2xl">
                            Zwischen Ayurveda-Programmen und der Rückkehr zu innerer Harmonie entdecken Sie die reiche Natur und die tiefen historischen Schätze Sri Lankas. Von der Umgebung des Resorts bis zu den Weltkulturerbestätten bieten wir Ihnen vielfältige Reisepläne an.
                        </p>
                    </div>
                </div>
            </div>
        </section>;
};
export default ToursHero;
